import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=5ab0728c&scoped=true&"
import script from "./Photo.vue?vue&type=script&lang=js&"
export * from "./Photo.vue?vue&type=script&lang=js&"
import style0 from "./Photo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Photo.vue?vue&type=style&index=1&id=5ab0728c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab0728c",
  null
  
)

export default component.exports